import {
    SupplierInfo,
    DirectorInfoVo,
    SupplierContactParam,
    ChannelContactParam,
    QueryQuickConfigUsingGetParams,
    QuickConfigVo,
    AutoCreditVo,
    InChannelPoolRuleVo,
    QueryPhoneUsingGetParams,
    AddContactInfoParam,
    UpdateContactInfoParam,
    FreightTempParam,
    LogisticsTempCopyParam,
    LogisticsTempCopyVo,
    ContactInfo,
    IdentitySwitchParam,
} from '@servicesTypings/drpRequest'
// 子账户管理
import { securityRequest, drpRequest, towerDrpRequest } from '@/utils/request'

// 获取短信验证码
export function sendCheckCode(data) {
    return securityRequest.post('/sms/sendCheckCode', {
        data,
    })
}

// 查询负责人信息
/**
 * 加载商家基础资料详情
 */
export function load(): API.Res<SupplierInfo> {
    return drpRequest.get('/supplierInfo/load')
}

// 查询渠道侧负责人信息
/**
 * 查询渠道负责人信息
 */
export function loadChannelDirectorInfo(): API.Res<DirectorInfoVo> {
    return drpRequest.get('/channel/loadDirectorInfo')
}

// 修改负责人信息-无手机号场景，检查是否已有手机号
/**
 * 修改负责人信息-无手机号场景，检查是否已有手机号
 */
export function updatePhoneWithCheck(data: SupplierContactParam): API.Res<object> {
    return drpRequest.post('/supplierInfo/updatePhoneWithCheck', { data })
}

/**
 * 渠道侧-修改负责人信息-无手机号场景，检查是否已有手机号
 */
export function updatePhoneWithCheckChannel(data: ChannelContactParam): API.Res<object> {
    return drpRequest.post('/channel/updatePersonWithCheck', { data })
}

// 获取快速配置 (右上角快速配置)
/**
 * 查询快速配置
 */
export function queryQuickConfig(params: QueryQuickConfigUsingGetParams): API.Res<QuickConfigVo> {
    return drpRequest.get('/config/queryQuickConfig', { params })
}

// 获取入驻流程配置 (入驻流程配置)
/**
 * 查询快速配置(入驻流程用)
 */
export function queryQuickConfigForSettled(): API.Res<QuickConfigVo> {
    return drpRequest.get('/config/queryQuickConfigForSettled')
}

// 更新快速配置
/**
 * 保存快速配置
 */
export function saveQuickConfig(data: QuickConfigVo): API.Res<object> {
    return drpRequest.post('/config/saveQuickConfig', { data })
}

// 更新自动授信
/**
 * 设置自动授信配置
 */
export function setAutoCredit(data: AutoCreditVo): API.Res<null> {
    return drpRequest.post('/supplyConfig/setAutoCredit', { data })
}

// 初始化供应商的分销商身份
/**
 * 初始化供应商的分销商身份
 */
export function initChannelForSupplier(): API.Res<object> {
    return drpRequest.post('/supplierInfo/initChannelForSupplier')
}

// 该商家是否在选商池中
/**
 * 查询我是否在找分销商池里
 */
export function fetchIsInDistributorPool(): API.Res<boolean> {
    return drpRequest.get('/findCooperation/channel/inChannelPool')
}

// 获取相应的供应商信息
/**
 * 查询进入分销商池的条件及当前商家的进度
 */
export function fetchDistributorInfo(): API.Res<InChannelPoolRuleVo> {
    return drpRequest.get('/findCooperation/channel/inChannelPooRule')
}

export enum FreightTemplateType {
    /** 所有分销商都使用一套运费模板 */
    UNIFIED = 'UNIFIED',

    /** 按分销商设置运费模板 */
    CHANNEL = 'CHANNEL',

    /** 按发货仓设置运费模板 */
    SEPARATE = 'SEPARATE',
}

/** 获取分销运费计算方式 */
export function getFreightType(): API.Res<FreightTemplateType> {
    return drpRequest.get('/config/getFreightType', {})
}

export function queryFreightRuleCanCopy(): API.Res<boolean> {
    return drpRequest.get('/config/queryFreightRuleIsCanCopy')
}

export function copyFreightRule(): API.Res<unknown> {
    return drpRequest.get('/config/copyFreightRule', {})
}

/**
 * 获取手机号
 */
export function queryPhone(params: QueryPhoneUsingGetParams): API.Res<string> {
    return drpRequest.get('/contactInfo/queryPhone', { params })
}

export function deleteContact(data) {
    return drpRequest.post(`/contactInfo/deleteContact?id=${data.id}`, { data })
}
/**
 * 新增联系方式
 */
export function addContact(data: AddContactInfoParam): API.Res<null> {
    return drpRequest.post('/contactInfo/addContact', { data })
}

/**
 * 修改联系方式
 */
export function updateContact(data: UpdateContactInfoParam): API.Res<null> {
    return drpRequest.post('/contactInfo/updateContact', { data })
}

export function checkHasSetFreightTemplate() {
    return drpRequest.get('/config/checkHasSetFreightTemplate')
}

// type	运费模板类型:1->设置全国包邮分销运费模板;0->设置全国包邮（偏远地区不发货）
/**
 * 设置全国包邮/全国包邮（偏远地区不发货）分销运费模板
 */
export function setNationalMailFreightTemplate(data: FreightTempParam): API.Res<null> {
    return drpRequest.post('/config/setNationalMailFreightTemplate', { data })
}

// 修改联系方式(商家站点用)
/**
 * 修改联系方式(商家站点用)
 */
export function updateContactForCompanySite(data: SupplierContactParam): API.Res<object> {
    return drpRequest.post('/supplierInfo/updateContactForCompanySite', { data })
}

// 复制分销运费模板
/**
 * 复制分销运费模板
 */
export function copyLogisticsTemplate(data: LogisticsTempCopyParam): API.Res<LogisticsTempCopyVo> {
    return drpRequest.post('/logistics/copyLogisticsTemplate', { data })
}

// 查询加密的供货负责人/联系人 列表
/**
 * 查询联系人列表信息
 */
export function listContactsOfMySupplierPrivacy(): API.Res<ContactInfo[]> {
    return drpRequest.get('/supplier/getContacts')
}

export enum FreightRuleModel {
    /** 默认模式 */
    DEFAULT = 'Default',

    /** 按分仓计算 */
    DRP_LEVEL = 'DrpLevel',

    /** 按分销商等级计算 */
    WAREHOUSE = 'Warehouse',
}

/** 查询默认运费模板设置情况 */
export interface DefaultFreightRuleCheckUpResult {
    /** 运费模板 */
    freightModel: FreightRuleModel

    /** 未设置默认运费模板的分销商 ID */
    drpNotSetRuleList: number[]

    /** 未设置默认运费模板的分销商等级  */
    levelNotSetRuleList: // eslint-disable-next-line no-magic-numbers
    (1 | 2 | 3 | 4 | 5)[]

    /** 默认模式 未设置运费模板 */
    notSetDefaultRule: boolean

    /** 分仓模式 未设置运费模板 */
    warehouseNotSetRule: boolean
}

// 商家未设置默认运费模板
export function notSetDefaultRule(): API.Res<DefaultFreightRuleCheckUpResult> {
    return towerDrpRequest.get('/freight/rule/notSetDefaultRule', {})
}

export interface NotSetDefaultRuleByFreightModelParams {
    /** 运费模板 */
    drpFreightModel: FreightRuleModel
}

export interface DefaultRuleByFreightModelCheckUpResult
    extends Omit<DefaultFreightRuleCheckUpResult, 'warehouseNotSetRule'> {
    /** 主仓库未设置默认运费模板 */
    masterWarehouseNotSetRule: boolean
}

/** 查询指定运费类型是否设置默认运费模板 */
export function notSetDefaultRuleByFreightModel(
    params: NotSetDefaultRuleByFreightModelParams,
): API.Res<DefaultRuleByFreightModelCheckUpResult> {
    return towerDrpRequest.get('/freight/rule/queryNotSetDefaultRuleByFreightModel', { params })
}

// 修改允许切换身份配置
/**
 * 修改允许切换身份配置
 */
export function updateIdentitySwitch(data: IdentitySwitchParam): API.Res<null> {
    return drpRequest.post('/config/updateIdentitySwitch', { data })
}
